import styled from "@emotion/styled";

import { fontMerriweather, fontRobotoCondensed, theme } from "shared/lib/styles";

export const Container = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 18px;
  font-family: ${fontMerriweather};
  line-height: 140%;
`;

export const SubTitle = styled.div`
  margin-block-end: 12px;

  font-weight: 700;
  font-size: 20px;
  font-family: ${fontMerriweather};

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 4px;
  }
`;

export const Title = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;

  margin-block-end: 12px;

  color: #4585ff;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: 140%;
  letter-spacing: 0;
  text-transform: uppercase;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 4px;
  }
`;
